export default __webpack_public_path__ + "static/media/studentDashboard.c00d6d6b.png";